<template>
  <div class="register">
    <h2>Register</h2>
    <form @submit.prevent="submit">
      <input type="text" placeholder="Vaš e-mail naslov" v-model="email" required />
      <input type="password" placeholder="Vnesite geslo" v-model="password" required />
      <button type="submit">Potrdi Registracijo</button>
    </form>
    <div class="success" v-if="successAlert">
      <p>
        Super, prijava v aplikacijo je bila uspešna. Sedaj lahko klikneš na poezavo:
        <a :href="baseURL + '/admin'">Admin</a>, v nadzorno ploščo.
      </p>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "Register",
  data() {
    return {
      email: null,
      password: null,
      successAlert: false
    };
  },
  methods: {
    submit() {
        var that = this;
      console.log("submit method has been called");
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(
          function(user) {
              console.log(user);
                that.successAlert = true;
              console.log("user has been created succesfully!")
          },
          function(err) {
            console.log("There was an error while creating a new user: " + err.message);
          }
        );
    }
  }
};
</script>

<style lang="less" scoped>
.register {
  width: 80%;
  margin: 0 auto;
  background-color: white;
  padding: 30px 40px;
  box-shadow: 0px 10px 50px rgb(184, 165, 124);
  text-align: center;

  h1 {
    margin-bottom: 20px;
    text-align: center;
  }

  & > p:first-of-type {
    width: 800px;
    margin: 0 auto;
    line-height: 1.6;

    @media screen and (max-width: 1024px) {
      width: 100%;
    }
  }

  hr {
    margin-bottom: 30px;
  }
}

.obrazec {
  width: 800px;
  margin: 0 auto;
  margin-bottom: 20px;
  margin-top: 40px;

  @media screen and (max-width: 1024px) {
    width: 100%;
  }

  h3 {
    text-align: center;
    margin-bottom: 0;
  }
}

form {
  margin-top: 50px;
  text-align: center;
  width: 800px;
  margin: 0 auto;

  @media screen and (max-width: 1024px) {
    width: 100%;
  }

  .form-inputs > label:nth-of-type(1),
  .form-inputs > label:nth-of-type(2) {
    display: block;
    margin-bottom: 10px;
  }

  p {
    margin-top: 20px;
  }
}

.success p {
    background-color: #EEE;
    padding: 20px;
    width: 500px;
    margin: 0 auto;
    border-left: 5px solid green;
    text-align: left;
}

input[type="text"],
input[type="password"] {
  outline: 0;
  border: 0;
  padding: 10px;
  font-size: 14px;
  border-radius: 4px;
  width: 300px;
  display: block;
  border: 1px solid #ccc;
  transition: ease-in-out all 0.3s;
  margin: 0 auto;

  &:focus {
    box-shadow: 10px 10px 15px #eee;
    transition: ease-in-out all 0.3s;
  }

  @media screen and (max-width: 1024px) {
    width: 90%;
  }

  &:nth-of-type(1) {
    margin-bottom: 20px;
  }

  &:nth-of-type(2) {
    margin-bottom: 10px;
  }
}

label {
  margin-right: 20px;
  font-weight: 600;
}

input[type="radio"] {
  margin-right: 5px;
}

button[type="submit"] {
  background-color: #6cb71a;
  color: white;
  outline: 0;
  border: 0;
  font-size: 18px;
  padding: 14px 15px;
  width: 200px;
  margin-top: 20px;
  box-shadow: 0px 10px 15px #ccc;
  margin-bottom: 40px;
  display: block;
  margin: 30px auto;
}
</style>